import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import InputMask from 'react-input-mask';

import { setForm } from '../actions/formulaire'

class InputText extends Component {

  constructor(props){
    super(props);
    this.state = {
      style : "",
      value : "",
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.reset){
      this.setState({style : "", value : ""})
    }
  }

  onChange(e){
    this.setState({value : e.target.value})
  }

  onFocus(){
    this.setState({style : "active"})
  }

  onBlur(){
    var obj = {}
    obj[this.props.index] = this.state.value
    this.props.setForm(obj)
    this.setState({style : ""})
  }

  render() {
    const error = this.props.error
    var style = this.state.style
    var value = this.state.value

    if(this.state.value !== ""){
      style = "active"
    }
    var input = null
    if(this.props.type === "phone"){
      input = <InputMask mask="99 99 99 99 99" maskChar=" " value={value} onChange={this.onChange.bind(this)} onFocus={this.onFocus.bind(this)} onBlur={this.onBlur.bind(this)} placeholder=""/>
    }else{
      input = <input type="text" value={value} onChange={this.onChange.bind(this)} onFocus={this.onFocus.bind(this)} onBlur={this.onBlur.bind(this)} placeholder="" />
    }

    return (
      <div className="containerInput">
        <label className={style}>{this.props.label}</label>
        {input}
        {(error) ? (<p className="warn">{error}</p>) : null}
      </div>
    )
  }

}
function mapDispatchToProps(dispatch){
  return bindActionCreators({
    setForm : setForm
  },dispatch)
}

function mapStateToProps(state) {
  return {
    reset : state.reset
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InputText);



// WEBPACK FOOTER //
// ./src/client/components/input.js